import { render, staticRenderFns } from "./EditCompanyProgramDescription.vue?vue&type=template&id=688d1f12"
import script from "./EditCompanyProgramDescription.vue?vue&type=script&lang=js"
export * from "./EditCompanyProgramDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports